import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Lenis from "lenis";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";

const PRIVATE = ["/family", "/personal", "/admin", "/gate", "/enterprise/"];

export const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);
  return null;
};

export const Loader = () => {
  const [show, setShow] = useState(true);
  useEffect(() => { const t = setTimeout(() => setShow(false), 1900); return () => clearTimeout(t); }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div className="fixed inset-0 z-[100] bg-[#0B1D14] flex flex-col items-center justify-center" exit={{ opacity: 0, transition: { duration: 0.8 } }} data-testid="loader">
          <svg width="120" height="140" viewBox="0 0 120 140">
            <motion.ellipse cx="60" cy="128" rx="10" ry="5" fill="#C9A24B" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ duration: 0.4 }} />
            <motion.path d="M60 126 C60 100 58 80 60 50" stroke="#C9A24B" strokeWidth="2.5" fill="none" strokeLinecap="round" initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 0.9, delay: 0.3 }} />
            <motion.path d="M60 90 C48 82 40 74 34 62 M60 72 C72 64 80 56 86 44 M60 60 C52 52 50 44 48 34" stroke="#C9A24B" strokeWidth="1.8" fill="none" strokeLinecap="round" initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 0.8, delay: 0.9 }} />
            {[[34, 60], [86, 42], [48, 32], [60, 46]].map(([x, y], i) => (
              <motion.circle key={i} cx={x} cy={y} r="5" fill="#E4C87F" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.3 + i * 0.1, type: "spring" }} />
            ))}
          </svg>
          <p className="mt-6 font-mono-x text-xs tracking-[0.4em] text-[#C9A24B]">MARAIS FAMILY</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

const RouteMeta = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    let m = document.querySelector('meta[name="robots"]');
    if (!m) { m = document.createElement("meta"); m.name = "robots"; document.head.appendChild(m); }
    m.content = PRIVATE.some((p) => pathname.startsWith(p)) ? "noindex, nofollow" : "index, follow";
    window.__lenis ? window.__lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const Layout = ({ children, bare = false }) => {
  const { pathname } = useLocation();
  return (
    <div className="grain min-h-screen" style={{ "--grain": 0.06 }}>
      <RouteMeta />
      {!bare && <Nav />}
      <motion.main key={pathname} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}>
        {children}
      </motion.main>
      <motion.div key={`leader-${pathname}`} className="pointer-events-none fixed inset-0 z-[80] bg-[#C9A24B]/10" initial={{ opacity: 1 }} animate={{ opacity: 0 }} transition={{ duration: 0.8 }} />
      {!bare && <Footer />}
    </div>
  );
};
